module.exports = __webpack_public_path__ + "img/Proactivity_Platinum.e9b4157b.png";